// extracted by mini-css-extract-plugin
export var section = "_36-1";
export var topNav = "_36-0";